import { useAuthStore, withAuthStore } from 'context/AuthStore'
import { useResErrors } from 'hooks'
import { createContext, useEffect, useRef, useState } from 'react'
import { filterInitialState, paginationInitialState } from './constants'
import { AuthService, CarService, SalesService } from 'lib/api'
import CsContractsService from 'lib/api/services/csContracts.service'
import { LoaderBackdrop } from 'asterX-UI/Loaders'
import { AllStatusesDeal } from '../../../constants/deals'
import moment from 'moment'
import BonusStoreProviderManager from '../Manager/BonusProvider/BonusProvider.manager'

export const HomeStoreContext = createContext({
  homeStore: {},
  homeStoreFunc: {}
})

const HomeStoreProviderSpp = props => {
  const _isMounted = useRef(true)
  const { standardCheck } = useResErrors()

  const {
    authStore: { user }
  } = useAuthStore()

  const [loading, setLoading] = useState(false)

  const [branches, setBranches] = useState([])
  const [subdivisions, setSubdivisions] = useState([])
  const [statuses, setStatuses] = useState([])
  const [managers, setManagers] = useState([])
  const [marks, setMarks] = useState([])
  const [models, setModels] = useState([])
  const [selectedMng, setSelectedMng] = useState(null)
  const [selectedBranch, setSelectedBranch] = useState(null)
  const [selectedSubdivision, setSelectedSubdivision] = useState(null)

  const [wlCount, setWlCount] = useState(0)
  const [wlList, setWlList] = useState([])
  const [wlFilter, setWlFilter] = useState(filterInitialState)
  const [wlTab, setWlTab] = useState(0)

  const [sppTab, setSppTab] = useState(0)

  const [pagination, setPagination] = useState(paginationInitialState)

  const getWlData = () => {
    const data = {
      globalId: wlFilter.id ? Number(wlFilter.id) : undefined,
      eventId: wlFilter.eventId || undefined,
      statusCodes:
        wlFilter?.statusCodes && wlFilter.statusCodes.length
          ? wlFilter.statusCodes
          : undefined,
      managers: selectedMng ? [selectedMng] : undefined,
      branchCodes: selectedBranch ? [selectedBranch] : undefined,
      subdivision: selectedSubdivision?.name || undefined,

      saleType: wlFilter.saleType || undefined,
      paymentType: wlFilter.paymentType || undefined,
      creationType: wlFilter.creationType || undefined,
      isRedirect: wlFilter.trade || undefined,
      carst: wlFilter.carst || undefined,
      ropCheck: wlFilter.ropCheck
        ? true
        : wlFilter.ropCheckFalse
        ? false
        : undefined,
      car:
        !!wlFilter.vin || !!wlFilter.marka
          ? {
              vin: wlFilter.vin || undefined,
              marka: wlFilter.marka?.name || undefined,
              model: wlFilter.model?.name || undefined
            }
          : undefined,
      client:
        !!wlFilter.phoneNumber ||
        !!wlFilter.firstName ||
        !!wlFilter.lastName ||
        !!wlFilter.iin
          ? {
              phoneNumber: wlFilter.phoneNumber || undefined,
              firstName: wlFilter.firstName || undefined,
              lastName: wlFilter.lastName || undefined,
              iin: wlFilter.iin || undefined
            }
          : undefined
    }

    data[`${wlFilter.dateType}DateFrom`] = wlFilter.dateFrom
      ? moment(wlFilter.dateFrom).format('YYYY-MM-DD')
      : undefined
    data[`${wlFilter.dateType}DateTo`] = wlFilter.dateTo
      ? moment(wlFilter.dateTo).format('YYYY-MM-DD')
      : undefined

    return data
  }

  const getWlList = async () => {
    setLoading(true)
    await getSaleList(
      getWlData(),
      pagination.limit,
      pagination.offset ? pagination.offset - 1 : 0
    )
    setLoading(false)
  }

  const getSaleList = async (data, limit, offset) => {
    const { getList } = SalesService

    if ([0].includes(wlTab)) {
      data.saleStatusTrackCode = '110'
      data.statusCodes = undefined
    }

    await getList(data, limit, offset * limit).then(res =>
      standardCheck(
        res,
        ({ data }) => {
          if (data?.listSales) {
            setWlList(data.listSales)
            setWlCount(data.countFiltered)
            setPagination(prevState => ({
              ...prevState,
              count: Math.ceil(data.countFiltered / prevState.limit)
            }))
          }
        },
        {
          onFail: () => {
            setWlList([])
            setWlCount(0)
            setPagination(prevState => ({
              ...prevState,
              offset: 0,
              count: 0
            }))
          }
        }
      )
    )
  }

  const handleFilterChange = event => {
    const name = event?.target?.name
    const value = event?.target?.value
    const isCheckbox = ['trade', 'ropCheck', 'carst', 'ropCheckFalse'].includes(
      name
    )

    setWlFilter(prevState => ({
      ...prevState,
      ...(name === 'ropCheck'
        ? { ropCheckFalse: false }
        : name === 'ropCheckFalse'
        ? { ropCheck: false }
        : {}),
      [name]: isCheckbox ? event.target.checked : value
    }))
  }

  const handleDateChange = (value, name) => {
    if (!value) {
      return
    }

    setWlFilter(prevState => ({
      ...prevState,
      [name]: new Date(value)
    }))
  }

  const onPaginationChange = async (e, newValue) => {
    setPagination(prevState => ({ ...prevState, offset: newValue }))

    setLoading(true)
    await getSaleList(
      getWlData(),
      pagination.limit,
      newValue ? newValue - 1 : 0
    )
    setLoading(false)
  }

  const handleClearFilter = async () => {
    setLoading(true)
    setWlFilter(filterInitialState)
    setPagination(paginationInitialState)

    const data = {
      statusCodes: AllStatusesDeal.map(c => c.code),
      managers: selectedMng ? [selectedMng] : undefined,
      branchCodes: selectedBranch ? [selectedBranch] : undefined
    }
    await getSaleList(data, pagination.limit, 0)
    setLoading(false)
  }

  useEffect(() => {
    AuthService.getBranches().then(res =>
      standardCheck(res, () => {
        if (res?.data) {
          setBranches(res.data.filter(b => user.branchList.includes(b.code)))
        }
      })
    )

    CsContractsService.getStatuses().then(res =>
      standardCheck(res, () => {
        if (res?.data) {
          setStatuses(res.data)
        }
      })
    )

    CarService.getBrands().then(res =>
      standardCheck(res, () => {
        if (res?.data) {
          setMarks(res.data)
        }
      })
    )

    return () => {
      _isMounted.current = false
    }
  }, [])

  useEffect(() => {
    if (selectedBranch) {
      setSelectedSubdivision(null)
      getSubdivisions()
    }
  }, [selectedBranch])

  useEffect(() => {
    if (selectedBranch || selectedSubdivision) {
      getManagers()
    }
  }, [selectedBranch, selectedSubdivision])

  const getSubdivisions = async () => {
    await AuthService.getSubdivisions(selectedBranch).then(res =>
      standardCheck(res, () => {
        if (res?.data) {
          setSubdivisions(res.data)
          setSelectedMng(null)
        }
      })
    )
  }

  useEffect(() => {
    setPagination(paginationInitialState)
    setLoading(true)
    setWlList([])
    setWlCount(0)
    getSaleList(getWlData(), pagination.limit, 0)
    setLoading(false)
  }, [wlTab])

  useEffect(() => {
    setWlFilter(prevState => ({
      ...prevState,
      model: undefined
    }))

    if (wlFilter.marka?.name) {
      CarService.getRuModels(wlFilter.marka.id).then(res =>
        standardCheck(res, () => {
          if (res?.data) {
            setModels(res.data)
          }
        })
      )
    }
  }, [wlFilter.marka])

  const getManagers = async () => {
    await AuthService.getUsers({
      roleCode: 'MANAGER',
      projectCode: 'CS_V2',
      isActive: true,
      offset: 0,
      limit: 100,
      userBranchCode: selectedBranch || user?.data?.branch?.code,
      subdivision: selectedSubdivision?.name || undefined
    }).then(res =>
      standardCheck(res, () => {
        if (res?.data?.userList) {
          setManagers(
            res.data.userList.map(e => ({
              ...e,
              fullName: [e.firstName, e.lastName].join(' ')
            }))
          )
        }
      })
    )
  }

  const returnContextByTab = () => {
    if (sppTab === 0) {
      return (
        <BonusStoreProviderManager homePrData={{ homeStore, homeStoreFunc }}>
          {props.children}
        </BonusStoreProviderManager>
      )
    }

    return props.children
  }

  const homeStore = {
    loading,
    pagination,

    branches,

    statuses,
    subdivisions,
    managers,
    marks,
    models,

    wlList,
    wlFilter,
    wlCount,
    wlTab,
    selectedBranch,
    selectedSubdivision,
    selectedMng,

    sppTab
  }

  const homeStoreFunc = {
    getWlList,

    handleFilterChange,
    handleDateChange,
    handleClearFilter,

    onPaginationChange,

    setLoading,
    setWlTab,
    setSppTab,
    setSelectedMng,
    setSelectedBranch,
    setSelectedSubdivision
  }

  return (
    <HomeStoreContext.Provider value={{ homeStore, homeStoreFunc }}>
      {returnContextByTab()}
      <LoaderBackdrop loading={loading} />
    </HomeStoreContext.Provider>
  )
}

export default withAuthStore(HomeStoreProviderSpp)
